<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 09:35:43
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="dialog">
        <el-dialog
            class="implement-remark"
            :show-close='false'
            :close-on-click-modal="false"
            :close-on-press-escap="false"
            :destroy-on-close="true"
            :visible.sync="implementVisible"
            @close="close"
            width="92%">
            <div class="implement-dialog">
                <div class="message">
                    <div>{{remakeType==1?'“完成”时输入数值':remakeType==2?'“未完成”时输入数值':'添加说明信息'}}</div>
                    <el-image
                        @click="closeStatus"
                        class="close-image"
                        :src="closebtn"></el-image>
                </div>

                <div class="task-name">
                    <div class="task-container">
                        <el-image
                        class="task-image"
                        :src="time"></el-image>
                        <div class="task">{{Message}}</div>
                    </div>
                    <div class="avatar-container">
                        <el-image
                        class="avatar-image"
                        fit="cover"
                        :src="ImgUrl|| avatar"></el-image>
                        <div class="name">{{ProfileName}}</div>
                    </div>
                </div>
                <div v-if="remakeType==1">
                    <el-input class="input" v-model="input" ></el-input>
                </div>
                <div v-if="remakeType!=3" class="select">
                    <template v-if="remakeType==1&&(InputType==1||InputType==2)">
                        <el-button @click="btnChange(item)" :class="['select-button', item.isChecked?'active-buton':'']"  v-for="(item) in models" :key="item.tvalue" type="primary" plain>
                            {{item.tvalue}}{{item.unit?item.unit:""}}
                        </el-button>
                    </template>
                    <template v-if="remakeType==2">
                        <el-button @click="statusChange(item.status)" :class="['select-button', item.status==localStatus?'active-buton':'']" v-for="(item) in statusList" :key="item.text" type="primary" plain>
                            {{item.text}}
                        </el-button>
                    </template>
                </div>
                
                <div>
                    <p class="illustrate">说明:</p>
                    <el-input
                        class="textarea"
                        type="textarea"
                        resize="none"
                        placeholder="请输入..."
                        v-model="remark">
                    </el-input>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="submit" type="primary" @click="sure">确 认</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import closebtn from '@/assets/imgs/close.png'
import time from '@/assets/imgs/time.png'
import avatar from '@/assets/imgs/avatar.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {
      isVisible:Boolean,
      remakeType:Number,
      Id:String,
      Message:String,
      ProfileName:String,
      InputType:Number,
      initStatus:Number,
      initModels:Array|String,
      initRemark:String,
      initInput:String,
      ImgUrl:String
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
        closebtn,
        time,
        avatar,
        implementVisible:false,
        statusList: 
        [
            {
                text: '拒绝',
                status: 1
            },
            {
                text: '缺席',
                status: 2
            },
            {
                text: '没有必要',
                status: 3
            },
            {
                text: '未完成',
                status: 4
            },
            {
                text: '延期',
                status: 5
            },
        ],
        localStatus:4,
        remark:'',
        input:'',
        models:[]
    }
  },
  // 计算属性
  computed: {
   
   
  },
  // 侦听器
  watch: {
    isVisible(val){
        this.implementVisible=val
    },
    initModels: {
        handler: function (val,oldValue) { 
            this.models=val
        },
    //   deep: true
    },
    initRemark(val){
        this.remark=val
    },
    initInput(val){
        this.input=val||''
    },
    initStatus(val){
        //0完成或者null在拒绝状态显示为4（仅给默认显示除非点击确认，不然不会更改Status）
        this.localStatus=val?val:4
    },
  
  },
  // 组件方法
  methods: {
    statusChange(status){
        this.localStatus=status
    },
    btnChange(item){
        
        if(this.InputType==1){
            if(!item.isChecked){
                this.models.map(model=>{
                    model.isChecked=false
                })
                item.isChecked=true
                this.input=` ${item.tvalue}`
            }else{
                item.isChecked=false
                this.input=this.input.replace(` ${item.tvalue}`,'')
            }
        }else{
            
            if(!item.isChecked){
                this.input+=` ${item.tvalue}`
            }else{
                this.input=this.input.replace(` ${item.tvalue}`,'')
            }
            item.isChecked=!item.isChecked
        }
    },
    sure(){
        this.implementVisible=false
        if(this.remakeType==1){
            this.$emit('execution',{
                id:this.Id,
                input:this.input,
                remark:this.remark,
                models:this.models,
                status:0
            })        
        }else{
            this.$emit('execution',{
                id:this.Id,
                remark:this.remark,
                status:this.remakeType==2?this.localStatus:0
            })
        }
    },
    closeStatus(){
        this.localStatus=4
        this.remark='',
        this.input='',
        this.models=[]
        this.implementVisible=false
        this.$emit('closeStatus',this.Id) 
    },
    close(){
        this.$emit('close') 
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {

  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>
.dialog >>> .el-dialog{
    width: 345px !important;
}
.dialog >>> .submit{
    background: #029FD1;
    border-color: #029FD1;
}
.select-button{
    width: 69px;
    height: 32px;
    font-size: 14px;
    margin: 5px 12px 5px 0px !important;
    padding: 6px;
    color: #029FD1 !important;
    border-color: #029FD1 !important;
}
.select-button:nth-child(4n){
    margin-right:0px !important;
}
.implement-remark >>> .el-dialog{
    border-radius: 5px;
}
.implement-remark >>> .el-dialog__header{
    height: 0px;
    padding: 0px;
}
.implement-remark >>> .el-dialog__body{
    padding: 14px 16px;
}
.message,.name,.task{
    font-weight: 500;
    font-family: 'PingFang SC Medium';
}
.message{
    position: relative;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    line-height: 22px;
    color: #0A0E10;
    text-indent: 7px;
}
.message::before{
    position: absolute;
    top: 3px;
    left: 0px;
    content: '';
    display: block;
    width: 4px;
    height: 17px;
    background: #029FD1;
    border-radius: 150px;
}
.close-image{
    width: 16px;
    height: 16px;
    padding-right: 7px;
}
.task-name{
    display: flex;
    justify-content: space-between;
    margin: 20px 0px;
}
.task-container,.avatar-container{
    display: flex;
    align-items: center;
}

.task-container{
    font-size: 16px;
    color: #029FD1;
}
.task-image{
    margin-right: 3px;
    width: 24px;
    height: 24px;
}
.avatar-container{
    font-size: 14px;
    color: #0A0E10;
}
.avatar-image{
    margin-right: 7px;
    width: 34px;
    height: 34px;
    border-radius: 17px;
    border: 1px solid #029FD1;
    box-sizing: border-box;
}
.illustrate{
    font-size: 14px;
    margin: 8px 0px;
    color: #0A0E10;
    font-family: 'PingFang SC Medium';
}
.textarea{
    font-weight: 400;
    color: #0A0E10;
    font-size: 12px;
}
.textarea >>> .el-textarea__inner {
    width: 100%;
    height: 190px;
    background: #E9F7FB;
    border-radius: 4px;
    padding: 12px!important;
    outline: none;
    border: none;
}
.submit{
    float: right;
    width: 69px;
    height: 32px;
    line-height: 8px;
    font-size: 14px;
    margin-top: 28px;
}
.dialog-footer::after{
    content: '';
    display: block;
    clear: both;
}
.input{
    margin-bottom: 10px;
    width: 315px;
    height: 32px;
    background: #F4F4F4;
    border-radius: 2px;
}
.input >>> .el-input__inner{
    width: 315px;
    height: 32px;
    background: #F4F4F4;
    border-radius: 2px;
    font-size: 12px;
}
.dialog >>> .el-button--primary.is-plain:hover{
    background: rgba(6, 160, 209, 0.15);
    color: #029FD1;
    border-color: #b3d8ff;
}
.active-buton{
    background: #029FD1 !important;
    color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/common/implement-remark.vue